import { ExtendedAreaModels } from '@bpd-library/utilities';
import { FILTER_NAMES } from '@features/properties/components/property-filter';
import { hasFilterUrl } from '@source/utilities/filters/urls';
import { translateItem } from '@source/utilities/hooks';

import { Filters } from './construct-filters';

const getHouseTypes = async (data: ExtendedAreaModels): Promise<[string[], string[]]> => {
    const houseTypes: string[] = [];

    // get unique houseTypes
    data.constructionNumbers.forEach(({ propertyType }) => {
        const { houseType } = propertyType || {};

        if (!propertyType || !houseType || houseTypes.includes(houseType)) return;

        houseTypes.push(houseType);
    });

    // Get unique houseTypes, for property types that don't have constructionNumbers
    data.propertyTypes.forEach(({ houseType, constructionNumbers }) => {
        const isUniqueHouseType = houseType && !houseTypes.includes(houseType);

        if (!constructionNumbers?.length && isUniqueHouseType) {
            houseTypes.push(houseType!);
        }
    });

    // Translate houseTypes
    const translatedHouseTypes = await Promise.all(
        houseTypes.map(
            async (houseType) => await translateItem(`PropertyTypeName-${houseType.toLowerCase()}`),
        ),
    );

    return [houseTypes, translatedHouseTypes];
};

export const setPropertyTypesFilters = async (data: ExtendedAreaModels, filters: Filters) => {
    const [houseTypes, translatedHouseTypes] = await getHouseTypes(data);
    const filterName = FILTER_NAMES.propertyTypes;

    filters[filterName] = {
        expanded: false,
        icon: 'specs-village-house',
        title: await translateItem('Filters.PropertyType.label'),
        dropdownLabel: await translateItem('Filters.PropertyType.dropdownLabel'),
        filterFunctions: {
            constructionNumber: (constructionNumber, filterInput) =>
                constructionNumber.propertyType?.houseType === filterInput.value,
            propertyType: (propertyType, filterInput) =>
                propertyType.houseType === filterInput.value,
            projectPhase: (projectPhase, filterInput) =>
                projectPhase.propertyTypes
                    ?.map(({ houseType }) => houseType)
                    .includes(filterInput.value) || false,
        },
        filterName,
        hasRangeValues: false,
        filters: {
            type: 'checkbox',
            components: houseTypes.map((houseType, i) => {
                return {
                    id: `${filterName}-${houseType}`,
                    label: translatedHouseTypes[i],
                    value: houseType,
                    name: filterName,
                    checked: hasFilterUrl(houseType, filterName),
                    type: 'checkbox',
                };
            }),
        },
    };
};
